import request from '../../../helpers/request';

const deleteClientDocument = async ({ clientId, documentId, fileName }) => {
  return await request.delete(
    '/HousingStock/client/documents',
    { clientId, documentId, fileName },
    'При удалении документа произошла ошибка',
    null
  );
};

export default deleteClientDocument;